import {CaAssessmentSessionService} from "./service/api/ca-assessment-session.service";
import {CaAssessmentSessionStepService} from "./service/api/ca-assessment-session-step.service";
import {ENTITY_SERVICE_REGISTRY, EntityServiceEntry} from "../../core/shared/dto/dto-service/entity-service-registry";
import {MvsCrudModeEnum} from "../../core/shared/service/crud/mvs-crud-mode.enum";
import {
    CaAssessmentTypeObjectComponent
} from "./component/object-components/ca-assessment-type-object-component/ca-assessment-type-object.component";

export const CA_ENTITY_PROVIDER = [
    {
        provide: ENTITY_SERVICE_REGISTRY,
        useValue: [
            ['ca.CaAssessmentSession', {route: '/ca/caAssessmentSessions', service: CaAssessmentSessionService}],
            ['ca.CaAssessmentSessionBehavior', {route: '/ca/caAssessmentSessionBehaviors'}],
            ['ca.CaAssessmentType', {route: '/ca/caAssessmentTypes', objectComponent: [{mode: MvsCrudModeEnum.update, component: CaAssessmentTypeObjectComponent}]}],
            ['ca.CaAssessmentTypeStep', {route: '/ca/caAssessmentTypeSteps'}],
            ['ca.CaAssessmentSessionStep', {route: '/ca/caAssessmentSessionSteps', service: CaAssessmentSessionStepService}],
            ['ca.CaAssessmentTypeCategory', {route: '/ca/caAssessmentTypeCategorys'}],
            ['ca.CaAssessmentTypeCategoryInsurableObject', {
                route: '/ca/caAssessmentTypeCategoryInsurableObjects'
            }],
            ['ca.CaAssessmentTypeCategoryPerson', {
                route: '/ca/caAssessmentTypeCategoryPersons'
            }],
            ['ca.CaAssessmentConfiguration', {route: '/ca/caAssessmentConfigurations'}],
            ['ca.CaAssessmentAbortReason', {route: '/ca/caAssessmentAbortReasons'}],
        ] as EntityServiceEntry[],
        multi: true
    }
];
